import * as React from 'react';
import classnames from 'classnames';
import SvgInline from '@latitude/svg-inline';
import './_logon-button.scss';

var LogonButton = function LogonButton(props) {
  var active = props.active,
      className = props.className,
      mobileVisible = props.mobileVisible,
      label = props.label,
      onClick = props.onClick;

  var handleButtonClick = function handleButtonClick(event) {
    event.preventDefault();

    if (onClick) {
      onClick();
    }
  };

  return /*#__PURE__*/React.createElement("div", {
    className: "logon-button-wrapper"
  }, /*#__PURE__*/React.createElement("button", {
    className: classnames('logon-button', className, {
      'mobile-visible': mobileVisible,
      'is-active': active
    }),
    type: "button",
    "aria-label": "Log in",
    onClick: function onClick(event) {
      return handleButtonClick(event);
    }
  }, /*#__PURE__*/React.createElement(SvgInline, {
    className: "profile-icon",
    name: "person"
  }), /*#__PURE__*/React.createElement("div", {
    className: "logon-button__label"
  }, label || 'Log in'), /*#__PURE__*/React.createElement(SvgInline, {
    "aria-label": "Down",
    name: active ? 'chevron-up' : 'chevron-down',
    className: "up-down-icon"
  })));
};

export default LogonButton;